export default theme => ({
  tertiaryText: {
    fontSize: theme.typography.h6.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    color: theme.palette.facet.primaryGray,
    textAlign: 'center',
    marginBottom: theme.spacing(4),
  },
  client: {
    marginBottom: theme.spacing(5),
  },
  riskToleranceValues: {
    width: '100%',
  },
});
